import { MAX_MOBILE_SCREEN, MAX_TABLET_SCREEN } from "../../constants/screen/devices";
import getRealSize from "../../functions/screen/getRealSize";

/**
 * Calculates city card width depending from window width
 * !IMPORTANT: this is rough calculation - originally for lowering image quality
 * @param {Number} screenWidth - max browser window width
 * @return {Number?} - `null` if failed to calculate width
 */
export default function getCityCardMaxWidth(screenWidth) {
  if (!screenWidth) {
    return null;
  }

  let width = 135;
  if (screenWidth > MAX_TABLET_SCREEN) {
    width = screenWidth / 4;
  } else if (screenWidth > MAX_MOBILE_SCREEN) {
    width = 250;
  }

  return getRealSize(width);
}
